// App.jsx
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";
import { PageProvider } from "./context/PageContext";
import { AuthContext } from "./context/AuthContext";
import { SocketProvider } from "./context/SocketContext";
import "reactflow/dist/style.css";
import { CallProvider } from "./context/CallContext";
import { NotificationProvider } from "./context/NotificationContext";
import { WorkspaceConfigProvider } from "./context/WorkspaceConfigContext";
import { OnboardingProvider } from "./context/OnboardingContext";
import { useBrandAssets } from "./hooks/useBrandAssets";
import { useRemoteI18nBundle } from "./hooks/useRemoteI18nBundle";
import UrlLocaleSync from "./i18n/UrlLocaleSync";
import TeamPresenceRouteSync from "./components/TeamPresenceRouteSync";
import TeamPresenceSocketEmitter from "./components/TeamPresenceSocketEmitter";

function I18nRemoteSync() {
  useRemoteI18nBundle();
  return null;
}

const AuthenticatedApp = () => (
  <SocketProvider>
    <I18nRemoteSync />
    <PageProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <UrlLocaleSync />
        <TeamPresenceRouteSync />
        <TeamPresenceSocketEmitter />
        <NotificationProvider>
          <CallProvider>
            {/* <== Provider de Configurações do Workspace */}
            <WorkspaceConfigProvider>
              <OnboardingProvider>
                <AppRoutes />
              </OnboardingProvider>
            </WorkspaceConfigProvider>
          </CallProvider>
        </NotificationProvider>
      </Router>
    </PageProvider>
  </SocketProvider>
);

const App = () => {
  useBrandAssets();
  const { t } = useTranslation("app");
  const { bearerToken, isAuthenticating } = useContext(AuthContext);

  if (isAuthenticating) {
    return <div>{t("loading")}</div>;
  }

  return bearerToken ? (
    <AuthenticatedApp />
  ) : (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <UrlLocaleSync />
      <AppRoutes />
    </Router>
  );
};

export default App;
